import React from 'react';

import { NavigationParamsContextProvider, useStackNavigationContext } from 'core/navigation';
import { Case1Screen, Case2Screen, Case3Screen, HomeScreen } from '../screen';
import { ROOT_ROUTE } from './Route.constant';

export const RootNavigator = React.memo(() => {
  const { current } = useStackNavigationContext();

  const ScreenElement = React.useMemo(() => {
    switch (current.screen) {
      case ROOT_ROUTE.HOME:
        return <HomeScreen />;
      case ROOT_ROUTE.CASE1:
        return <Case1Screen />;
      case ROOT_ROUTE.CASE2:
        return <Case2Screen />;
      case ROOT_ROUTE.CASE3:
        return <Case3Screen />;
      default:
        throw new Error('RootNavigator: unknown screen type!');
    }
  }, [current]);

  return <NavigationParamsContextProvider params={current.params}>{ScreenElement}</NavigationParamsContextProvider>;
});
